import styled from 'styled-components';
import { useUIStore } from '../../../../hooks/stores/uiStore';
import { IconButton } from '../../../common/IconButton';

export const SidebarTopbarIcons = () => {
  const [UIData, setUIData] = useUIStore();

  return (
    <>
      <DrawerToggleIcon>
        <IconButton
          iconClassName={UIData.isSidebarOpen ? 'icon-sidebar-close' : 'icon-sidebar-open'}
          onClick={() =>
            setUIData({
              isSidebarOpen: UIData.isSidebarOpen ? false : true,
            })
          }
        />
      </DrawerToggleIcon>
      <DrawerIcons>
        <IconButton
          iconClassName="icon-elements"
          isActive={UIData.sidebarDrawerPage === 'elements'}
          onClick={() => setUIData({ sidebarDrawerPage: 'elements' })}
        />
        <IconButton
          iconClassName="icon-assets"
          isActive={UIData.sidebarDrawerPage === 'assets'}
          onClick={() => setUIData({ sidebarDrawerPage: 'assets' })}
        />
        <IconButton
          iconClassName="icon-window"
          isActive={UIData.sidebarDrawerPage === 'window'}
          onClick={() => setUIData({ sidebarDrawerPage: 'window' })}
        />
      </DrawerIcons>
    </>
  );
};

const DrawerToggleIcon = styled.div`
  flex-basis: 45px;
  min-width: 45px;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const DrawerIcons = styled.div`
  box-sizing: border-box;
  flex: 1;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
`;
